<div class="order">
  <header class="header flex justify-between items-center py-2.5 px-4 max-w-screen-lg mx-auto desktop:py-4 deskop:px-0">
    <figure class="header_logo_container">
      <img src="{{ brandLogo }}" alt="Driven Entrepreneur Logo" class="header__logo max-w-fulll" />
    </figure>
    <div class="header__customerService text-xs text-right leading-4 desktop:text-base desktop:leading-7">
      <div class="font-bold">Questions? <a href="tel:{{ customerServicePhone }}" class="text-brandPrimary4">{{ customerServicePhone }}</a></div>
      <p class="font-normal desktop:hidden">{{ customerServiceHours_Mobile }}</p>
      <p class="hidden-mobile">{{ customerServiceHours_Desktop }}</p>
    </div>
  </header>

  <article class="main pt-5 pb-12 px-4 bg-brandPrimary2 desktop:py-20">
    <section id="orderForm-validation-error-box" class="errors mb-5">
      <div class="errors__row" *ngIf="!couponValidation">
        <div col-12 class="errors__col">
          <ul class="errors__list">
            <li *ngIf="!couponValidation" class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"
                [innerHTML]="getLabelCheckout('couponinvalid') ? getLabelCheckout('couponinvalid') : 'Sorry, the coupon code you have entered is invalid. Please check the code and try again.'">Sorry,
                the <strong>coupon code</strong> you have entered is invalid. Please check
                the code and try again.</span>
            </li>
          </ul>
        </div>
      </div>
  <div class="errors__row" *ngIf="
       !hasBackendError &&
       (submittedAccountForm || submittedPaymentForm) &&
       (
         (accountForm && accountForm.invalid) ||
         (accountForm && accountForm.valid && accountForm.controls && accountForm.controls['state'] && accountForm.controls['state'].value === '' && statesList && statesList.length > 0) ||
         (braintreeEnabled && braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) || (!braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment ) )) ||
         (!isSelectedCB2 && diffAddress && diffAddress.invalid) ||
         (paymentForm && paymentForm.invalid && !braintreePayPalTokenizedPayment) ||
         rejectOrder
       )
     ">
        <!-- Currently, we have a temporary fix for red border showing at the top even we have a successfull transaction. Need to refactor the ngIf above to figure out which conditions needs to be modified. -->
        <div col-12 class="errors__col"
          [ngClass]="{ 'errors__col--noBorder': (!accountForm.invalid && !paymentForm.invalid && !diffAddress?.invalid && !rejectOrder) }">
          <p *ngIf="!rejectOrder && accountForm.invalid" class="errors__info"
            [innerHTML]="getLabelCheckout('pleasecheck') ? getLabelCheckout('pleasecheck') : 'Please check the following errors'">
            Please сheck the following errors</p>
          <ul class="errors__list">

            <!-- REJECT ORDER -->
            <li class="errors__item" *ngIf="rejectOrder">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{rejectOrderMessage.header}}</strong></span>
            </li>
            <li class="errors__item" *ngIf="rejectOrder">
              <span class="errors__text">{{rejectOrderMessage.body}}</span>
            </li>

            <!-- ACCOUNT FORM -->
            <li class="errors__item"
              *ngIf="accountForm.controls['firstName'].invalid && accountForm.controls['firstName'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('firstName') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['firstName'].invalid && accountForm.controls['firstName'].errors.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelCheckout('firstName')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['lastName'].invalid && accountForm.controls['lastName'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('lastName') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['lastName'].invalid && accountForm.controls['lastName'].errors.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelCheckout('lastName')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['phone'].invalid && accountForm.controls['phone'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('phone') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['phone'].invalid && accountForm.controls['phone'].errors.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelCheckout('phone')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['email'].invalid && accountForm.controls['email'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('email') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item" *ngIf="
              accountForm.controls['email'].invalid &&
              (
                accountForm.controls['email'].errors.email ||
                accountForm.controls['email'].errors.invalidValidEmail
              ) &&
              accountForm.controls['email'].value &&
              accountForm.controls['email'].value.length > 0
            ">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>Email</strong> {{ getLabelCheckout('address is invalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['confirmEmail'].invalid && accountForm.controls['confirmEmail'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('confirmEmail') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item" *ngIf="
              accountForm.controls['confirmEmail'].invalid &&
              (
                accountForm.controls['confirmEmail'].errors.email ||
                accountForm.controls['confirmEmail'].errors.invalidValidEmail
              ) &&
              accountForm.controls['confirmEmail'].value &&
              accountForm.controls['confirmEmail'].value.length > 0
            ">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelCheckout('confirmEmail')}}</strong> {{
                getLabelCheckout('address is invalid')}}.</span>
            </li>
            <li class="errors__item" *ngIf="
              accountForm.controls['confirmEmail'].invalid &&
              (
                accountForm.controls['email'].invalid &&
                accountForm.controls['email'].errors.invalidConfirmEmails ||
                accountForm.controls['confirmEmail'].errors.invalidConfirmEmails
              ) &&
              accountForm.controls['email'].value &&
              accountForm.controls['email'].value.length > 0 &&
              accountForm.controls['confirmEmail'].value &&
              accountForm.controls['confirmEmail'].value.length > 0
            ">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelCheckout('confirmEmail')}}</strong> does not match
                Email.</span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['street'].invalid && accountForm.controls['street'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('addressTC') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['street'].invalid && accountForm.controls['street'].errors.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelCheckout('addressTC')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['city'].invalid && accountForm.controls['city'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('city') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['city'].invalid && accountForm.controls['city'].errors.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelCheckout('city')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['zipPostalCode'].invalid && accountForm.controls['zipPostalCode'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('zipTC') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['zipPostalCode'].invalid && accountForm.controls['zipPostalCode'].errors.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelCheckout('zipTC')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['country'].invalid && accountForm.controls['country'].errors.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('country') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>
            <li class="errors__item"
              *ngIf="accountForm.controls['state'].value === '' && statesList && statesList.length > 0">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">
                <strong>{{ getLabelCheckout('state') }} </strong>
                <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
              </span>
            </li>

            <!-- SHIPPING ADDRESS -->
            <div *ngIf="!isPayPalBillingAgreementApproved && buttonList[0].isPlaceOrder">
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['firstNameShipping']?.invalid && diffAddress?.controls?.['firstNameShipping']?.errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('firstName')}}</strong> <span>
                    Is a required Shipping information field</span>.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['firstNameShipping']?.invalid && diffAddress?.controls?.['firstNameShipping']?.errors?.pattern">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('firstName')}}</strong> {{
                  getLabelCheckout('containsinvalid')}}.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['lastNameShipping']?.invalid && diffAddress?.controls?.['lastNameShipping']?.errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('lastName')}}</strong> <span>
                    Is a required Shipping information field</span>.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['lastNameShipping']?.invalid && diffAddress?.controls?.['lastNameShipping']?.errors?.pattern">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('lastName')}}</strong> {{
                  getLabelCheckout('containsinvalid')}}.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['shipAddress']?.invalid && diffAddress?.controls?.['shipAddress']?.errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('addressTC')}}</strong> <span>
                    Is a required Shipping information field</span>.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['shipAddress']?.invalid && diffAddress?.controls?.['shipAddress']?.errors?.pattern">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('addressTC')}}</strong> {{
                  getLabelCheckout('containsinvalid')}}.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['shipCity']?.invalid && diffAddress?.controls?.['shipCity']?.errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('city')}}</strong> <span>
                    Is a required Shipping information field</span>.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['shipCity']?.invalid && diffAddress?.controls?.['shipCity']?.errors?.pattern">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('city')}}</strong> {{
                  getLabelCheckout('containsinvalid')}}.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['shipPostal']?.invalid && diffAddress?.controls?.['shipPostal']?.errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('zipTC')}}</strong> <span>
                    Is a required Shipping information field</span>.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['shipPostal']?.invalid && diffAddress?.controls?.['shipPostal']?.errors?.pattern">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('zipTC')}}</strong> {{
                  getLabelCheckout('containsinvalid')}}.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['shipCountry']?.invalid && diffAddress?.controls?.['shipCountry']?.errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('country')}}</strong> <span>
                    Is a required Shipping information field</span>.</span>
              </li>
              <li class="errors__item"
                *ngIf="diffAddress?.controls?.['shipState']?.value === '' && differentAddressStatesList && differentAddressStatesList.length > 0">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelShipping('state')}}</strong> <span>
                    Is a required Shipping information field</span>.</span>
              </li>
            </div>

            <!-- PAYMENT FORM -->
            <!-- This error is only for braintree hosted fields on our checkout pages so we have !enableCyberSource as one of the conditionals which implies that the checkout page fields are Braintree -->
            <div
              *ngIf="braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) || (!enableCyberSource && !braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment && braintreeHostedFieldsErrorHandler()))">
              <li class="errors__item">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"
                  [innerHTML]="getLabelCheckout('pleaseselect') ? getLabelCheckout('pleaseselect') : 'Please select a payment method'">Please
                  select a payment method.</span>
              </li>
            </div>

            <!-- These errors are for credit card fields using Cybersource and non for Braintree credit card fields so we have enableCyberSource && !braintreePayPalTokenizedPayment as the conditionals -->
            <div
              *ngIf="(!braintreeInstance && !isPayPalBillingAgreementApproved && buttonList[0].isPlaceOrder) || (enableCyberSource && !braintreePayPalTokenizedPayment)">
              <li class="errors__item"
                *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['nameOnCard'] && paymentForm.invalid && paymentForm.controls['nameOnCard'].errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelPayment('nameCard') }}</strong> <span>
                    is a required Billing information field</span>.</span>
              </li>

              <li class="errors__item"
                *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['nameOnCard'] && paymentForm.invalid && paymentForm.controls['nameOnCard'].errors?.pattern">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelPayment('nameCard')}}</strong> {{
                  getLabelCheckout('containsinvalid')}}.</span>
              </li>

              <li class="errors__item"
                *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['number'] && paymentForm.invalid && paymentForm.controls['number'].errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelPayment('cardNumber')}}</strong> <span>
                    is a required Billing information field</span>.</span>
              </li>

              <li class="errors__item"
                *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['number'] && paymentForm.invalid && paymentForm.controls['number'].errors && (paymentForm.controls['number'].errors.invalidTypeNumber || paymentForm.controls['number'].errors.invalidNumber)">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text">Invalid <strong>credit card number</strong>.</span>
              </li>

              <li class="errors__item"
                *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['expCard'] && paymentForm.controls['expCard'].errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelPayment('monthDateTC')}}</strong> <span>
                    is a required Billing information field</span>.</span>
              </li>

              <li class="errors__item"
                *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['expCard'] && paymentForm.controls['expCard'].errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelPayment('yearDateTC')}}</strong> <span>
                    is a required Billing information field</span>.</span>
              </li>

              <li class="errors__item" *ngIf="
                submittedPaymentForm && paymentForm?.controls && 
                paymentForm.controls['expmonth'] && paymentForm.controls['expyear'] &&
                paymentForm.invalid &&
                (
                  paymentForm.controls['expmonth'].errors?.cardExpired ||
                  paymentForm.controls['expyear'].errors?.cardExpired
                )
              ">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelPayment('expirationDate')}}</strong> is invalid. Card has
                  expired.</span>
              </li>

              <li class="errors__item"
                *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['code'] && paymentForm.invalid && paymentForm.controls['code'].errors?.required">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelPayment('cvvTC')}}</strong> <span>
                    is a required Billing information field</span>.</span>
              </li>

              <li class="errors__item"
                *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['code'] && paymentForm.invalid && paymentForm.controls['code'].errors && (paymentForm.controls['code'].errors.minlength || paymentForm.controls['code'].errors.maxlength)">
                <img src="{{ warningImg }}" alt="" class="errors__image">
                <span class="errors__text"><strong>{{ getLabelPayment('cvvTC')}}</strong> is invalid.</span>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </section>

    <section class="form__grid" [ngClass]="{'submitted__errors': (submittedAccountForm &&
    (
      (accountForm && accountForm.invalid) ||
      (accountForm && accountForm.valid && accountForm.controls && accountForm.controls['state'] && accountForm.controls['state'].value === '' && statesList && statesList.length > 0) ||
      (isSelectedCB2 && accountForm && accountForm.invalid) ||
      (braintreeEnabled && braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) || (!braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment ) )) ||
  
      (isSelectedCB2 && accountForm && accountForm.valid && accountForm.controls && accountForm.controls['shipState'] && accountForm.controls['shipState'].value === '' && differentAddressStatesList && differentAddressStatesList.length > 0)  ||
      (!isSelectedCB2 && diffAddress && diffAddress.invalid) ||
      rejectOrder
    ) ||
    submittedPaymentForm &&
    (
      (paymentForm && paymentForm.invalid) ||
      rejectOrder
    ))}">

      <main class="order__contentWrapper max-w-screen-lg mx-auto desktop:flex desktop:flex-col desktop:gap-7">

        <h2 class="order__title font-semibold leading-10 text-brandPrimary">Safe and Secure <br class="desktop:hidden">
          Check Out</h2>

        <section class="order__container flex flex-col gap-5 desktop:flex-row-reverse desktop:gap-9">
          <!--ORDER DETAILS-->
          <article
            class="order__detailsWrapper mt-5 pt-2.5 pb-5 w-full max-w-full mx-auto desktop:my-0 desktop:py-5 desktop:mx-0">

            <hr class="order__hr w-full desktop:hidden">

            <div class="order__benefitsWrapper text-sm flex flex-col gap-2.5 justify-center my-4 desktop:mt-2.5">
              <div class="font-bold flex justify-between items-center">              
                <h4 class="order__benefitsTitle font-bold">Shark Profit Machine™</h4>
                <span class="text-brandPrimary">$2,000&nbsp;Value</span>
              </div>
              <p class="order__benefitsSubtitle">Here's Exactly What You Get:</p>
              <ul class="order__benefitsList leading-6 flex flex-col gap-2">
                <li class="flex gap-2.5">
                  <img src="{{ CDN_IMAGES.ORANGE_CHECK }}" alt="Check" class="order__checkIcon">
                  <span>Shark Profit Machine Video Training <span class="font-bold text-brandPrimary">$1,250&nbsp;Value</span></span>
                </li>
                <li class="flex gap-2.5">
                  <img src="{{ CDN_IMAGES.ORANGE_CHECK }}" alt="Check" class="order__checkIcon">
                  <span>Shark Profit Machine Workbook & Checklists <span class="font-bold text-brandPrimary">$125&nbsp;Value</span></span>
                </li>
                <li class="flex gap-2.5">
                  <img src="{{ CDN_IMAGES.ORANGE_CHECK }}" alt="Check" class="order__checkIcon">
                  <span>Implementation Session & Step-by-Step Action Plan <span class="font-bold text-brandPrimary">$625&nbsp;Value</span></span>
                </li>
                <li class="flex gap-2.5">
                  <img src="{{ CDN_IMAGES.ORANGE_CHECK }}" alt="Check" class="order__checkIcon">
                  <span>Lifetime Access </span>
                </li>
                <li class="flex gap-2.5">
                  <img src="{{ CDN_IMAGES.ORANGE_CHECK }}" alt="Check" class="order__checkIcon">
                  <span>U.S. Based VIP Customer Support </span>
                </li>
                <li class="flex gap-2.5">
                  <img src="{{ CDN_IMAGES.ORANGE_CHECK }}" alt="Check" class="order__checkIcon">
                  <span>30-Day Money Back Guarantee</span>
                </li>
              </ul>
            </div>

            <hr class="order__hr w-full">

            <h3 class="order__detailsTitle text-brandPrimary font-bold leading-7 my-4">Order Summary</h3>

            <div class="order__lineItems my-4">
              <div class="flex justify-between items-center">
                <span>Subtotal:</span>
                <span>{{ currentFunnel?.standardPrice | dynamicCurrency:currency
                  }}</span>
              </div>

              <div class="text-brandPrimary4 font-bold flex items-center justify-between my-3">
                <div class="flex items-center gap-2">
                  <img src="{{ CDN_IMAGES.SALE_TAG }}" alt="Sale Tag" class="order__saleTag w-4 h-4">
                  <span>Discount:</span>
                </div>
                <span>-{{ (currentFunnel?.standardPrice - currentFunnel?.offerPrice) | dynamicCurrency:currency }}</span>
              </div>

              <div class="flex justify-between items-baseline leading-4">
                <span>Sales Tax:</span>
                <span>{{ (totalTax) | dynamicCurrency:currency }}</span>
              </div>
              <span *ngIf="currentFunnel?.installmentsAvailable" class="order__salesTaxNote italic">Sales tax of the full amount is added to today’s total</span>
            </div>

            <hr class="order__hr w-full">

            <div class="order__lineItems text-xl flex justify-between items-center mt-3 mb-2">
              <span class="font-bold">You Pay <span *ngIf="currentFunnel?.installmentsAvailable">Today</span>:</span>
              <div class="flex items-baseline gap-2">
                <span class="text-xs">USD</span>
                <span *ngIf="!currentFunnel?.installmentsAvailable" class="font-bold">{{ (currentFunnel && currentFunnel.offerPrice || 1) + totalTax |
                  dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</span>

                <span *ngIf="currentFunnel?.installmentsAvailable" class="font-bold">{{ getInitialInstallmentAmount() + totalTax |
                  dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</span>
              </div>
            </div>

            <div *ngIf="currentFunnel?.installmentsAvailable" class="order__lineItems text-sm leading-6 font-normal text-center">+ {{ getTotalInstallments() - 1 }} additional payments of {{ getInitialInstallmentAmount() |
              dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</div>
            <div *ngIf="currentFunnel?.installmentsAvailable" class="order__paymentsTotalText italic text-center mb-3">Payments will total {{ currentFunnel?.offerPrice + totalTax | dynamicCurrency:currency}}</div>

            <hr class="order__hr w-full">

            <!-- Digital Wallet Buttons -->
            <article *ngIf="!hidePaypalButton" class="digitalWallet__buttonsWrapper">
              <div class="digitalWallet__buttonsContainer">
                <div class="digitalWallet__buttonsWrap" [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">            
                  <!-- PayPal Button -->
                  <div [hidden]="showPayPalPayButton" class="digitalWallet__paypalBtnContainer">
                    <div [hidden]="braintreeHidePayPalButton || isBraintreeLoading || !braintreeEnabled" id="paypal-button"
                      class="digitalWallet__paypalBtn"></div>
                  </div>
                </div>
              </div>
            </article>

          </article>

          <!-- CUSTOMER INFORMATION -->
          <article class="customer__informationWrapper w-full">
            <section class="customer__informationContainer">
              <account-form-v2 class="account-form_wrapper"
                [braintreeDefaultZipPostalCode]="braintreeDefaultZipPostalCode"
                [braintreeDefaultCountry]="braintreeDefaultCountry" [euSpecified]="euSpecified" [guest]="guest"
                (countryChange)="onCountryChange($event)" [statesList]="statesList" [countriesList]="countriesList"
                [submittedAccountForm]="submittedAccountForm" [emailToConfirm]="emailToConfirm"
                (validateAddressAndCalculateTaxes)="validateAddressAndCalculateTaxes($event)"
                (rememberAccountInformation)="rememberAccountInformation()" (readyToCreateLead)="readyToCreateLead()"
                (emitConfirmEmail)="emailToConfirm=$event" (linkForm)="accountForm=$event"
                [showCustomerInformationTitle]="true" [showBillingInformationTitle]="true" [showOptionalLabel]="true">
              </account-form-v2>
            </section>

            <!-- PAYMENT INFORMATION -->
            <section [hidden]="isBraintreeLoading || isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder"
              class="payment_informationWrapper">
            
              <article class="payment__informationContainer flex flex-col gap-3 bg-white p-5 rounded-lg mt-5" [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
                <!-- PAYMENT INFORMATION -->
                <div class="form__row " [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
                  <div col-12 [innerHTML]="getLabelCheckout('paymentInformationTC')"></div>
                </div>
            
                <!-- Credit Card Icons-->
                <div class="creditCardType__wrapper"><gh-card-type-indicator class="">
                    <div
                      class="creditCardType__container flex flex-col gap-2 w-full desktop:flex-row desktop:gap-unset desktop:justify-between desktop:items-center">
                      <div class="creditCardType__title text-sm font-bold"> Credit Card </div>
                      <div class="creditCardType__imgWrapper inline-flex max-h-[24px] desktop:ml-auto">
                        <figure class="creditCardType__imgContainer max-h-full mr-[8px] flex max-w-[40px] justify-center">
                          <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24"
                            aria-labelledby="pi-visa" class="ng-star-inserted">
                            <title id="pi-visa">Visa</title>
                            <path opacity=".07"
                              d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
                            <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32">
                            </path>
                            <path
                              d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z"
                              fill="#142688"></path>
                            <title xmlns="http://www.w3.org/2000/svg" id="pi-visa">Visa</title>
                            <path xmlns="http://www.w3.org/2000/svg" opacity=".07"
                              d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
                            <path xmlns="http://www.w3.org/2000/svg" fill="#fff"
                              d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path>
                            <path xmlns="http://www.w3.org/2000/svg"
                              d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z"
                              fill="#142688"></path>
                          </svg>
                        </figure>
                        <figure class="creditCardType__imgContainer max-h-full mr-[8px] flex max-w-[40px] justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24"
                            aria-labelledby="pi-american_express" class="ng-star-inserted">
                            <title id="pi-american_express">American Express</title>
                            <g fill="none">
                              <path fill="#000"
                                d="M35,0 L3,0 C1.3,0 0,1.3 0,3 L0,21 C0,22.7 1.4,24 3,24 L35,24 C36.7,24 38,22.7 38,21 L38,3 C38,1.3 36.6,0 35,0 Z"
                                opacity=".07"></path>
                              <path fill="#006FCF"
                                d="M35,1 C36.1,1 37,1.9 37,3 L37,21 C37,22.1 36.1,23 35,23 L3,23 C1.9,23 1,22.1 1,21 L1,3 C1,1.9 1.9,1 3,1 L35,1">
                              </path>
                              <path fill="#FFF"
                                d="M8.971,10.268 L9.745,12.144 L8.203,12.144 L8.971,10.268 Z M25.046,10.346 L22.069,10.346 L22.069,11.173 L24.998,11.173 L24.998,12.412 L22.075,12.412 L22.075,13.334 L25.052,13.334 L25.052,14.073 L27.129,11.828 L25.052,9.488 L25.046,10.346 L25.046,10.346 Z M10.983,8.006 L14.978,8.006 L15.865,9.941 L16.687,8 L27.057,8 L28.135,9.19 L29.25,8 L34.013,8 L30.494,11.852 L33.977,15.68 L29.143,15.68 L28.065,14.49 L26.94,15.68 L10.03,15.68 L9.536,14.49 L8.406,14.49 L7.911,15.68 L4,15.68 L7.286,8 L10.716,8 L10.983,8.006 Z M19.646,9.084 L17.407,9.084 L15.907,12.62 L14.282,9.084 L12.06,9.084 L12.06,13.894 L10,9.084 L8.007,9.084 L5.625,14.596 L7.18,14.596 L7.674,13.406 L10.27,13.406 L10.764,14.596 L13.484,14.596 L13.484,10.661 L15.235,14.602 L16.425,14.602 L18.165,10.673 L18.165,14.603 L19.623,14.603 L19.647,9.083 L19.646,9.084 Z M28.986,11.852 L31.517,9.084 L29.695,9.084 L28.094,10.81 L26.546,9.084 L20.652,9.084 L20.652,14.602 L26.462,14.602 L28.076,12.864 L29.624,14.602 L31.499,14.602 L28.987,11.852 L28.986,11.852 Z">
                              </path>
                            </g>
                          </svg>
                        </figure>
                        <figure class="creditCardType__imgContainer max-h-full mr-[8px] flex max-w-[40px] justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24" role="img" width="38" height="24"
                            aria-labelledby="pi-master" class="ng-star-inserted">
                            <title id="pi-master">Mastercard</title>
                            <path opacity=".07"
                              d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
                            <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32">
                            </path>
                            <circle fill="#EB001B" cx="15" cy="12" r="7"></circle>
                            <circle fill="#F79E1B" cx="23" cy="12" r="7"></circle>
                            <path fill="#FF5F00"
                              d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z">
                            </path>
                            <title xmlns="http://www.w3.org/2000/svg" id="pi-master">Mastercard</title>
                            <path xmlns="http://www.w3.org/2000/svg" opacity=".07"
                              d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
                            <path xmlns="http://www.w3.org/2000/svg" fill="#fff"
                              d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path>
                            <circle xmlns="http://www.w3.org/2000/svg" fill="#EB001B" cx="15" cy="12" r="7"></circle>
                            <circle xmlns="http://www.w3.org/2000/svg" fill="#F79E1B" cx="23" cy="12" r="7"></circle>
                            <path xmlns="http://www.w3.org/2000/svg" fill="#FF5F00"
                              d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z">
                            </path>
                          </svg>
                        </figure>
                        <figure class="creditCardType__imgContainer max-h-full mr-[8px] flex max-w-[40px] justify-center">
                          <svg viewBox="0 0 38 24" width="38" height="24" role="img" aria-labelledby="pi-discover" fill="none"
                            xmlns="http://www.w3.org/2000/svg" class="ng-star-inserted">
                            <title id="pi-discover">Discover</title>
                            <path fill="#000" opacity=".07"
                              d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
                            <path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z" fill="#fff">
                            </path>
                            <path
                              d="M3.57 7.16H2v5.5h1.57c.83 0 1.43-.2 1.96-.63.63-.52 1-1.3 1-2.11-.01-1.63-1.22-2.76-2.96-2.76zm1.26 4.14c-.34.3-.77.44-1.47.44h-.29V8.1h.29c.69 0 1.11.12 1.47.44.37.33.59.84.59 1.37 0 .53-.22 1.06-.59 1.39zm2.19-4.14h1.07v5.5H7.02v-5.5zm3.69 2.11c-.64-.24-.83-.4-.83-.69 0-.35.34-.61.8-.61.32 0 .59.13.86.45l.56-.73c-.46-.4-1.01-.61-1.62-.61-.97 0-1.72.68-1.72 1.58 0 .76.35 1.15 1.35 1.51.42.15.63.25.74.31.21.14.32.34.32.57 0 .45-.35.78-.83.78-.51 0-.92-.26-1.17-.73l-.69.67c.49.73 1.09 1.05 1.9 1.05 1.11 0 1.9-.74 1.9-1.81.02-.89-.35-1.29-1.57-1.74zm1.92.65c0 1.62 1.27 2.87 2.9 2.87.46 0 .86-.09 1.34-.32v-1.26c-.43.43-.81.6-1.29.6-1.08 0-1.85-.78-1.85-1.9 0-1.06.79-1.89 1.8-1.89.51 0 .9.18 1.34.62V7.38c-.47-.24-.86-.34-1.32-.34-1.61 0-2.92 1.28-2.92 2.88zm12.76.94l-1.47-3.7h-1.17l2.33 5.64h.58l2.37-5.64h-1.16l-1.48 3.7zm3.13 1.8h3.04v-.93h-1.97v-1.48h1.9v-.93h-1.9V8.1h1.97v-.94h-3.04v5.5zm7.29-3.87c0-1.03-.71-1.62-1.95-1.62h-1.59v5.5h1.07v-2.21h.14l1.48 2.21h1.32l-1.73-2.32c.81-.17 1.26-.72 1.26-1.56zm-2.16.91h-.31V8.03h.33c.67 0 1.03.28 1.03.82 0 .55-.36.85-1.05.85z"
                              fill="#231F20"></path>
                            <path d="M20.16 12.86a2.931 2.931 0 100-5.862 2.931 2.931 0 000 5.862z" fill="url(#pi-paint0_linear)">
                            </path>
                            <path opacity=".65" d="M20.16 12.86a2.931 2.931 0 100-5.862 2.931 2.931 0 000 5.862z"
                              fill="url(#pi-paint1_linear)"></path>
                            <path
                              d="M36.57 7.506c0-.1-.07-.15-.18-.15h-.16v.48h.12v-.19l.14.19h.14l-.16-.2c.06-.01.1-.06.1-.13zm-.2.07h-.02v-.13h.02c.06 0 .09.02.09.06 0 .05-.03.07-.09.07z"
                              fill="#231F20"></path>
                            <path
                              d="M36.41 7.176c-.23 0-.42.19-.42.42 0 .23.19.42.42.42.23 0 .42-.19.42-.42 0-.23-.19-.42-.42-.42zm0 .77c-.18 0-.34-.15-.34-.35 0-.19.15-.35.34-.35.18 0 .33.16.33.35 0 .19-.15.35-.33.35z"
                              fill="#231F20"></path>
                            <path d="M37 12.984S27.09 19.873 8.976 23h26.023a2 2 0 002-1.984l.024-3.02L37 12.985z" fill="#F48120">
                            </path>
                            <defs>
                              <linearGradient id="pi-paint0_linear" x1="21.657" y1="12.275" x2="19.632" y2="9.104"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F89F20"></stop>
                                <stop offset=".25" stop-color="#F79A20"></stop>
                                <stop offset=".533" stop-color="#F68D20"></stop>
                                <stop offset=".62" stop-color="#F58720"></stop>
                                <stop offset=".723" stop-color="#F48120"></stop>
                                <stop offset="1" stop-color="#F37521"></stop>
                              </linearGradient>
                              <linearGradient id="pi-paint1_linear" x1="21.338" y1="12.232" x2="18.378" y2="6.446"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F58720"></stop>
                                <stop offset=".359" stop-color="#E16F27"></stop>
                                <stop offset=".703" stop-color="#D4602C"></stop>
                                <stop offset=".982" stop-color="#D05B2E"></stop>
                              </linearGradient>
                            </defs>
                          </svg>
                        </figure>
                        <figure class="creditCardType__imgContainer max-h-full mr-[8px] flex max-w-[40px] justify-center">
                          <svg width="38" height="24" role="img" aria-labelledby="pi-jcb" viewBox="0 0 38 24"
                            xmlns="http://www.w3.org/2000/svg" class="ng-star-inserted">
                            <title id="pi-jcb">JCB</title>
                            <g fill="none" fill-rule="evenodd">
                              <g fill-rule="nonzero">
                                <path d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                                  fill="#000" opacity=".07"></path>
                                <path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" fill="#FFF">
                                </path>
                              </g>
                              <path d="M11.5 5H15v11.5a2.5 2.5 0 0 1-2.5 2.5H9V7.5A2.5 2.5 0 0 1 11.5 5z" fill="#006EBC">
                              </path>
                              <path d="M18.5 5H22v11.5a2.5 2.5 0 0 1-2.5 2.5H16V7.5A2.5 2.5 0 0 1 18.5 5z" fill="#F00036">
                              </path>
                              <path d="M25.5 5H29v11.5a2.5 2.5 0 0 1-2.5 2.5H23V7.5A2.5 2.5 0 0 1 25.5 5z" fill="#2AB419">
                              </path>
                              <path
                                d="M10.755 14.5c-1.06 0-2.122-.304-2.656-.987l.78-.676c.068 1.133 3.545 1.24 3.545-.19V9.5h1.802v3.147c0 .728-.574 1.322-1.573 1.632-.466.144-1.365.221-1.898.221zm8.116 0c-.674 0-1.388-.107-1.965-.366-.948-.425-1.312-1.206-1.3-2.199.012-1.014.436-1.782 1.468-2.165 1.319-.49 3.343-.261 3.926.27v.972c-.572-.521-1.958-.898-2.919-.46-.494.226-.737.917-.744 1.448-.006.56.245 1.252.744 1.497.953.467 2.39.04 2.919-.441v1.01c-.358.255-1.253.434-2.129.434zm8.679-2.587c.37-.235.582-.567.582-1.005 0-.438-.116-.687-.348-.939-.206-.207-.58-.469-1.238-.469H23v5h3.546c.696 0 1.097-.23 1.315-.415.283-.25.426-.53.426-.96 0-.431-.155-.908-.737-1.212zm-1.906-.281h-1.428v-1.444h1.495c.956 0 .944 1.444-.067 1.444zm.288 2.157h-1.716v-1.513h1.716c.986 0 1.083 1.513 0 1.513z"
                                fill="#FFF" fill-rule="nonzero"></path>
                            </g>
                          </svg>
                        </figure>
                      </div>
                    </div>
                  </gh-card-type-indicator>
                </div>
            
                <!-- Payment Forms -->
                <div class="form__row  payment_row" [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
                  <div col-12 class="payment_col">
            
                    <div [hidden]="!braintreeClientToken" class="braintree-card-row hidden">
                      <div class="payment_form_col col" col-12="">
                        <div [hidden]="!braintreeClientToken" id="dropin-container"></div>
                        <div [hidden]="!braintreeClientToken" id="dropin-container-paypal" style="display:none;">
                          <div (click)="whatispaypal()" class="braintree-dropin braintree-loaded">
                            <div style="padding:10px;cursor:pointer;">Paying with PayPal</div>
                            <div data-braintree-id="methods-container" class="braintree-methods--active">
                              <div class="braintree-method braintree-method--active" tabindex="0" role="button">
                                <div class="braintree-method__icon-container braintree-method__delete-container">
                                  <div class="braintree-method__icon braintree-method__delete">
                                    <svg width="48" height="29">
                                      <use xlink:href="#iconX"></use>
                                    </svg>
                                  </div>
                                </div>
            
                                <div class="braintree-method__logo">
                                  <svg width="40" height="24" class="">
                                    <use xlink:href="#logoPayPal"></use>
                                  </svg>
                                </div>
            
                                <div class="braintree-method__label">{{ braintreePayPalEmail }}<br>
                                  <div class="braintree-method__label--small">PayPal</div>
                                </div>
            
                                <div class="braintree-method__icon-container braintree-method__check-container">
                                  <div class="braintree-method__icon braintree-method__check">
                                    <svg height="100%" width="100%">
                                      <use xlink:href="#iconCheck"></use>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div data-braintree-id="toggle" class="braintree-large-button braintree-toggle" tabindex="0"
                              role="button">
                              <span (click)="braintreeChooseAnotherWayToPay($event)">Remember my information and choose
                                another way
                                to
                                pay</span>
                            </div>
                          </div>
                        </div>
                        <a [hidden]="braintreeDropinValid || !braintreeDropInEnabled" class="item_link_bt_dr  braintreelink"
                          (click)="navigateToPageByGenericUrl('/what-is-this', 'name', 'width=500,height=330')"
                          href="/what-is-this">What is this?</a>
            
                      </div>
                    </div>
            
                    <div [hidden]="!braintreeClientToken || braintreeDropInEnabled || enableCyberSource"
                      id="dropin-container-hosted-fields"
                      class="dropin-container-hosted-fields braintree-card-row form__row  payment_row">
            
                      <div class="payment_form_row formBT2">
                        <div size="12" class="payment_form_col">
                          <form class="btpayment_form" id="paymentForm" novalidate>
            
                            <div class="form_item_wrapper btrow hidden">
                              <label class="form_item_label" for="typeOfCardBT">{{ getLabelPayment('cardType')
                                }}</label>
                              <div class="form_item_elements  btelements">
            
                                <select class="item_select item_cartType" fixscrollonmobileios="" id="typeOfCardBT"
                                  name="typeOfCard" required="">
                                  <option value="visa">Visa</option>
                                  <option value="mastercard">Mastercard</option>
                                  <option value="amex">Amex</option>
                                </select>
            
                              </div>
                            </div>
            
                            <div class="form_item_wrapper btrow cardNumberBTerrorWrapper">
                              <label class="form_item_label" for="cardNumberBT">{{ getLabelPayment('cardNumber')
                                }}</label>
                              <div class="form_item_elements btelements">
                                <div id="cardNumberBT" class="inputBT"></div>
                                <div id="cardNumberBTerror" class="hidden">
                                  <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                                </div>
                              </div>
                            </div>

                            <div class="form_item_wrapper btrow btfirstrow nameOnCardBTerrorWrapper">
                              <label class="form_item_label" for="nameOnCardBT">{{ getLabelPayment('nameCard')
                                }}</label>
                              <div class="form_item_elements btelements">
                                <div id="nameOnCardBT" class="inputBT"></div>
                                <div id="nameOnCardBTerror" class="hidden">
                                  <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                                </div>
                              </div>
                            </div>
            
                            <div class="exp-cvv-wrapper">
                              <div class="form_item_wrapper btrow btrowhalf expirationDateBTerrorWrapper">
                                <label class="form_item_label" for="expirationDateBT">{{
                                  getLabelPayment('expirationDate')
                                  }}</label>
                                <div class="form_item_elements btelements">
                                  <div id="expirationDateBT" class="inputBT"></div>
                                  <div id="expirationDateBTerror" class="hidden">
                                    <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                                  </div>
                                  <span class="item_info_bt hidden">{{ getLabelPayment('expirationDateLabelBT')}}</span>
                                </div>
                              </div>
            
                              <div class="form_item_wrapper btrow btrowhalf form_item_code btlastrow cvcCodeBTerrorWrapper">
                                <label class="form_item_label" for="cvcCodeBT">{{ getLabelPayment('cvvV2') }}</label>
                                <div class="form_item_elements btelements">
                                  <div id="cvcCodeBT" class="inputBT"></div>
                                  <div id="cvcCodeBTerror" class="hidden">
                                    <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                                  </div>
                                  <a class="new_item_link"
                                    (click)="navigateToPageByGenericUrl('/what-is-this', 'name', 'width=500,height=330')"
                                    href="/what-is-this">{{ getLabelPayment('whatsThis') }}</a>
            
                                </div>
            
                              </div>
                            </div>
                          </form>
            
                        </div>
                      </div>
                    </div>
            
                    <payment-form-v2 [braintreeDefaultCountry]="braintreeDefaultCountry"
                      [hidden]="braintreeClientToken && !enableCyberSource" [cardName]="cardName" [cardType]="cardType"
                      (linkForm)="paymentForm=$event" [cardDetails]="cardDetails" [submittedPaymentForm]="submittedPaymentForm"
                      [monthArray]="monthArray" [yearArray]="yearArray"></payment-form-v2>
                  </div>
                </div>
              </article>
            </section>
          </article>
        </section>

        <section col-12 class="button__wrapper flex flex-col gap-5 justify-center text-center mt-5">
          <a (click)="navigateToPageByGenericUrl('/safe-order', 'name', 'width=400,height=400')" class="text-sm font-normal text-brandPrimary leading-6 flex gap-3 items-center justify-center w-fit mx-auto">
            <figure>
              <img src="{{ CDN_IMAGES.LOCK_ICON }}" alt="Money Back Guarantee" class="w-4 h-5">
            </figure>
            <span>Your Order is Safe and Secure</span>
          </a>

          <div class="text-sm font-normal leading-6">
            <p>By clicking Submit Order, you agree to Driven&nbsp;Entrepreneur <br class="desktop:hidden"> <a
                href="https://legal.drivenentrepreneur.com/terms" target="_blank"
                class="text-brandPrimary underline transition-opacity duration-300 hover:opacity-80 cursor-pointer">Terms
                & Conditions</a>
              and <a href="https://legal.drivenentrepreneur.com/privacy-policy" target="_blank"
                class="text-brandPrimary underline transition-opacity duration-300 hover:opacity-80 cursor-pointer">Privacy
                Policy</a>.</p>
          </div>
          <!-- Non-Braintree SUBMIT ORDER button. So credit card fields uses Cybersource -->
          <!-- braintreeClient Token will be present on all braintree pages when BT is on paypal button or the credit card fields are BT -->
          <!-- enableCyberSource is new variable we are using when we are combining BT paypal and Cybersource for credit card field on our page -->
          <!-- braintreePayPalTokenizedPayment will be null on page load as we only get the token when there's a BT paypal payment. That's why we have protected it by pairing with braintreeClientToken-->
          <!-- We have used [hidden] instead of ngIf as we are switching the non-BT SUBMIT ORDER button with BT SUBMIT ORDER button below when we have a paypal BT transaction -->

          <button
            [hidden]="braintreeClientToken && !enableCyberSource || (braintreeClientToken && braintreePayPalTokenizedPayment)"
            id="order-form-submit-btn" type="submit"
            [disabled]="(!buttonList[0].isPlaceOrder && isConsentStatus) || (!termsAgreed && submitOrderCheckBox) || isBraintreeLoading || isSubmittingOrder"
            (click)="isPayPalBillingAgreementApproved ?
              submitPayPalOrder(accountForm) :
              buttonList[0].isPlaceOrder ?
              onPayWithDifferentAddressClicked(accountForm, paymentForm, diffAddress) :
              submitAmazonPay(accountForm)"
            class="order__ctaButton p-1.5 self-stretch rounded-full bg-brandPrimary3 text-brandPrimary text-xl leading-7 font-bold text-center cursor-pointer w-full mx-auto">
            <span class="order__ctaButtonText">{{ getLabelCheckout('submitorder') ? getLabelCheckout('submitorder') :
              'Submit Order' }}</span>
            <figure class="order__ctaButtonIconWrapper bg-white flex items-center justify-center rounded-full">
              <img src="{{ CDN_IMAGES.CTAARROW_ICON }}" alt="Arrow Icon" class="order__ctaButtonIcon">
            </figure>
          </button>

          <!-- Straight up Braintree SUBMIT ORDER button -->
          <button [hidden]="!braintreeClientToken || (enableCyberSource && !braintreePayPalTokenizedPayment)"
            id="order-form-submit-btn" type="submit"
            [disabled]="(!buttonList[0].isPlaceOrder && isConsentStatus) || (!termsAgreed && submitOrderCheckBox) || isBraintreeLoading || isSubmittingOrder"
            (click)="payWithBrainTree(accountForm, diffAddress)"
            class="order__ctaButton p-1.5 self-stretch rounded-full bg-brandPrimary3 text-brandPrimary text-xl leading-7 font-bold text-center cursor-pointer w-full mx-auto">
            <span class="order__ctaButtonText">{{ getLabelCheckout('submitorder') ? getLabelCheckout('submitorder') :
              'Submit Order' }}</span>
            <figure class="order__ctaButtonIconWrapper bg-white flex items-center justify-center rounded-full">
              <img src="{{ CDN_IMAGES.CTAARROW_ICON }}" alt="Arrow Icon" class="order__ctaButtonIcon">
            </figure>
          </button>
        </section>

      </main>
    </section>
  </article>

  <footer-common></footer-common>

</div>